module.exports = __webpack_public_path__ + "img/2845bc2a9218a55b7d674b8ebc1befe2.png";